export default {
    type: 'date',
    format: {},
    default: {
        logic: 'min',
        period: 'day'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'rolling'],
        period: ['day', 'week', 'month', 'year']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Date Commented',
        category: ['User', 'Comments'],
        description: 'Date of when a comment was made.',
        summarise: {
            prefix: 'Commented'
        },
        unit: function(rule) {

            return rule.setting.period

        }
    },
    rules: {
        linked: [],
        legacy: ['comment.date']
    }
}
